// extracted by mini-css-extract-plugin
export default {"backTop":"backTop--3JSC0","article":"article--1lSpS","hero":"hero--6Oe91","listDisc":"listDisc--1yODr","code":"code--1s-dt","block":"block--1E6CR","backBottom":"backBottom--ZdfXz"};